'use client'

import type { CartDetailsProps } from '@maestro/commerce-blocks/components/cart/cart.types'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

import '@maestro/commerce-blocks/components/cart/styles/cart.scss'

const CartDetails = dynamic(
  () => import('@maestro/commerce-blocks/components/cart/cart-details')
)

export default function CartModal({
  recommendations,
  usps,
  loyaltyVouchers,
  cartItemsSlot,
}: CartDetailsProps) {
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()

  useEffect(() => {
    addModal({
      key: 'cart',
      hash: 'cart',
      Component: (
        <SlideInBody>
          <CartDetails
            recommendations={recommendations}
            usps={usps}
            loyaltyVouchers={loyaltyVouchers}
            cartItemsSlot={cartItemsSlot}
          />
        </SlideInBody>
      ),
      props: {
        title: t('cart.shopping-cart'),
        customClassName: 'cart',
      },
    })
  }, [addModal, cartItemsSlot, loyaltyVouchers, recommendations, t, usps])

  return null
}
